<div class="overflow-auto swipe-menu edp-scroll-disabled">
    <ul class="d-flex list-unstyled pl-3">
        <ng-container *ngFor="let item of menu$ | async">
            <li [id]="item.reference || ''" *ngIf="item.visible" class="list-inline-item">
                <a class="d-block d-lg-none" *ngIf="item.routerPath" (click)="setNewActiveMenuItem(item)"
                    [ngClass]="{ active: item.isActive }">
                    <i *ngIf="!item.name" class="{{ item.icon }}" aria-hidden="true"></i>
                    <span *ngIf="item.name">{{ item.name | translate }}</span>
                </a>
                <a class="d-block d-lg-none" *ngIf="item.externalLink" [edpExternalLink]="item.externalLink | translate"
                    [ngClass]="{ active: item.isActive }">
                    <span>{{ item.name | translate }}</span>
                </a>
            </li>
        </ng-container>
    </ul>
</div>